import { useConfirmModule } from '@/store/global/appComponents/appconfirm';
import { OpenConfirm, OpenConfirmProps } from '@/store/global/appComponents/appconfirm/actions';

function show(props: OpenConfirmProps) {
    const store = useConfirmModule();
    store.dispatch(new OpenConfirm(props));
}

const confirm = { show };
export { confirm };
